/**
 * Countdown timer section component
 * Displays countdown to beta enrollment deadline
 * @param {Object} props - Component props
 * @param {Object} props.countdown - Countdown object with days, hours, minutes, seconds
 */
function CountdownSection({ countdown }) {
  // Format countdown values for display
  const days = countdown.days;
  const formattedHours = String(countdown.hours).padStart(2, '0');
  const formattedMinutes = String(countdown.minutes).padStart(2, '0');
  const formattedSeconds = String(countdown.seconds).padStart(2, '0');

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-700">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-center">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 bg-orange-500 text-white text-sm font-bold px-4 py-2 rounded-full mb-4">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 4 2-7L2 10h7l3-7z"/>
            </svg>
            DEAL ENDS SOON
          </div>

          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-2">
            Beta Tutor Enrollment Closes In:
          </h2>

          {/* Supporting text */}
          <p className="text-lg sm:text-xl text-white/90 mb-2 max-w-2xl mx-auto">
            Only 20 lifetime-free founder spots available
          </p>
          <p className="text-base text-orange-300 font-semibold mb-8">
            Join a community of innovative tutors shaping Wurlo's future
          </p>

          {/* Countdown timer grid */}
          <div className="grid grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl mx-auto mb-8">
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border border-white/30 flex flex-col items-center justify-center">
              <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2 text-center tabular-nums">{days}</div>
              <div className="text-xs sm:text-base font-medium text-white/90 text-center">Days</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border border-white/30 flex flex-col items-center justify-center">
              <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2 text-center tabular-nums">{formattedHours}</div>
              <div className="text-xs sm:text-base font-medium text-white/90 text-center">Hours</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border border-white/30 flex flex-col items-center justify-center">
              <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2 text-center tabular-nums">{formattedMinutes}</div>
              <div className="text-xs sm:text-base font-medium text-white/90 text-center">Minutes</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 border border-white/30 flex flex-col items-center justify-center">
              <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-2 text-center tabular-nums">{formattedSeconds}</div>
              <div className="text-xs sm:text-base font-medium text-white/90 text-center">Seconds</div>
            </div>
          </div>

          {/* CTA button */}
          <a href="#waitlist" className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-orange-500 to-red-500 px-6 sm:px-8 py-4 text-white text-base sm:text-lg font-bold hover:from-orange-600 hover:to-red-600 focus-ring shadow-2xl transform hover:scale-105 transition-all mb-6 whitespace-nowrap">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2l3 7h7l-5.5 4 2 7L12 17l-6.5 4 2-7L2 10h7l3-7z"/>
            </svg>
            Secure Your Beta Tutor Spot
          </a>

          {/* Benefits list */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-white/90">
            <p className="flex items-center gap-2">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Early access
            </p>
            <p className="flex items-center gap-2">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Post-Beta once in a lifetime discount
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CountdownSection;
